import * as React from "react";
const SvgSuccess = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 6L9.32806 18L4 12.8528", stroke: "#297A00", strokeWidth: 2, strokeMiterlimit: 10 }));
export default SvgSuccess;
